export default __webpack_public_path__ + "static/media/Root of Death.c6be65c8.jpg";